<mdc-dialog-title>
  Table Attribute: ${attributeInstance.name}
</mdc-dialog-title>
<mdc-dialog-content>
  <table style="border: 1.5px solid; width: 100%; table-layout: fixed;" aria-describedby="Table">
    <tr style="border: 0.75px solid;">
      <th repeat.for="col of table" style="border: 0.75px solid; width: 120px; text-align: center;">${col[0].attribute.name}</th>
    </tr>
    <tr repeat.for="i of rows.length" style="border: 0.75px solid;">
      <td repeat.for="j of rows[i].length" style="border: 0.75px solid; width: 120px; text-align: center;">

      <!-- if input type is text -->
      <mdc-text-field if.bind="columns[j].ui_component=='text' || columns[j].ui_component=='Text'" class="mdc-text-field" value.bind="rows[i][j].value" change.trigger="fieldChange(rows[i][j])" ></mdc-text-field>

      <!-- if input type is slider -->
      <div style="display: flex; flex-direction: row; align-items: center; width: 100%;" if.bind="columns[j].ui_component=='slider'||columns[j].ui_component=='Slider'">
        <span style="margin-right: 8px; white-space: nowrap; width: 25px;">Val:${rows[i][j].value | numerise:rows[i][j].metaAttribute.default_value:facetsAll[j][0]}</span>
        <mdc-slider style="flex: 1;" min.bind="facetsAll[j][0]" max.bind="facetsAll[j][1]" value.bind="rows[i][j].value | numerise:rows[i][j].metaAttribute.default_value:facetsAll[j][0]" step.bind="facetsAll[j][2] || 1" click.trigger="fieldChange(rows[i][j])"></mdc-slider>
      </div>

      <!-- if input type is dropdown -->
      <mdc-select if.bind="columns[j].ui_component=='dropdown' || columns[j].ui_component=='Dropdown'" label.bind="label"
        value.bind="rows[i][j].value"
        change.trigger="fieldChange(rows[i][j])" required
        style="display: flex;">
        <mdc-list>
          <mdc-list-item repeat.for="facet of facetsAll[j]"
            value.bind="facet">${facet}</mdc-list-item>
        </mdc-list>
      </mdc-select>

      <!-- if input type is button -->
       <div style="display: flex; flex-direction: column; align-items: center; width: 100%;" if.bind="columns[j].ui_component=='button' || columns[j].ui_component=='Button'">
        <mdc-button outlined click.trigger="openNestedDialog(i, j)"
        style="width: 100%;">${rows[i][j].name}
      </mdc-button>
      <mdc-dialog view-model.ref="nestedDialogs[i][j]">
        <dialog-table-attribute
          attribute-instance.bind="rows[i][j]" 
          attribute.bind="columns[j].attribute"
          current-dialog.bind="nestedDialogs[i][j]"></dialog-table-attribute>
      </mdc-dialog>
      </div>

      </td>
    </tr>
    </table>  
     
</mdc-dialog-content>
<mdc-dialog-actions>
  <button mdc-button click.trigger="ok($event)">Ok</button>
  <button mdc-button click.trigger="close($event)">Close</button>
  <button mdc-button click.trigger="createRow()">Create Row</button>
</mdc-dialog-actions>
